import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js"

export default class extends Controller {
  static targets = [
    "checkbox",
    "selectAll",
    "counter",
    "actionBar",
    "banner",
    "bannerPageText",
    "bannerAllText",
    "couponIdsField",
    "selectAllPagesField",
    "absoluteFields",
    "relativeFields",
    "datePicker",
    "form"
  ]

  static values = {
    totalUnused: Number,
    pageCount: Number
  }

  connect() {
    this.allPagesSelected = false
    this.updateUI()
    this.initDatePicker()
  }

  initDatePicker() {
    if (!this.hasDatePickerTarget) return

    flatpickr(this.datePickerTarget, {
      locale: French,
      dateFormat: "Y-m-d",
      altInput: true,
      altFormat: "d/m/Y",
      minDate: "today",
      defaultDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    })
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => cb.checked = checked)
    this.allPagesSelected = false
    this.updateUI()
  }

  toggle() {
    this.allPagesSelected = false
    this.updateSelectAllState()
    this.updateUI()
  }

  selectAllPages(event) {
    event.preventDefault()
    this.allPagesSelected = true
    this.selectAllTarget.checked = true
    this.checkboxTargets.forEach(cb => cb.checked = true)
    this.updateUI()
  }

  deselectAll(event) {
    event.preventDefault()
    this.allPagesSelected = false
    this.selectAllTarget.checked = false
    this.checkboxTargets.forEach(cb => cb.checked = false)
    this.updateUI()
  }

  showAbsoluteFields() {
    this.absoluteFieldsTarget.style.display = "block"
    this.relativeFieldsTarget.style.display = "none"
  }

  showRelativeFields() {
    this.absoluteFieldsTarget.style.display = "none"
    this.relativeFieldsTarget.style.display = "block"
  }

  submitForm() {
    if (this.allPagesSelected) {
      this.selectAllPagesFieldTarget.value = "true"
      this.couponIdsFieldTarget.value = ""
    } else {
      this.selectAllPagesFieldTarget.value = ""
      const selectedIds = this.checkboxTargets
        .filter(cb => cb.checked)
        .map(cb => cb.value)
      this.couponIdsFieldTarget.value = selectedIds.join(",")
    }
  }

  updateSelectAllState() {
    const total = this.checkboxTargets.length
    const checked = this.checkboxTargets.filter(cb => cb.checked).length

    if (checked === 0) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    } else if (checked === total) {
      this.selectAllTarget.checked = true
      this.selectAllTarget.indeterminate = false
    } else {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = true
    }
  }

  updateUI() {
    const checkedCount = this.allPagesSelected
      ? this.totalUnusedValue
      : this.checkboxTargets.filter(cb => cb.checked).length

    this.counterTarget.textContent = checkedCount

    this.actionBarTarget.style.display = checkedCount > 0 ? "block" : "none"

    if (this.hasBannerTarget && this.pageCountValue > 1) {
      const allOnPageChecked = this.selectAllTarget.checked && !this.selectAllTarget.indeterminate
      this.bannerTarget.style.display = allOnPageChecked ? "block" : "none"

      if (this.hasBannerPageTextTarget && this.hasBannerAllTextTarget) {
        this.bannerPageTextTarget.style.display = this.allPagesSelected ? "none" : "inline"
        this.bannerAllTextTarget.style.display = this.allPagesSelected ? "inline" : "none"
      }
    }
  }
}
